import { render, staticRenderFns } from "./GendersInput.vue?vue&type=template&id=a9f8bb14&scoped=true"
import script from "./GendersInput.vue?vue&type=script&lang=ts"
export * from "./GendersInput.vue?vue&type=script&lang=ts"
import style0 from "./GendersInput.vue?vue&type=style&index=0&id=a9f8bb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8bb14",
  null
  
)

export default component.exports